import { securedApiRequest } from "./SecuredApi";

/**
 * Updates user profile details.
 * @param {Object} profileData - User profile fields to update.
 */
export const updateUserProfile = async (profileData) => {
    return securedApiRequest("/change-user-details/", "POST", profileData);
};

/**
 * Fetch the user's current address.
 * @returns {Promise<Object>} A promise resolving to the user's address data.
 */
export const fetchUserAddress = async () => {
    return securedApiRequest("/get-user-address/", "GET");
};

/**
 * Save or update the user's address.
 * @param {Object} addressData - Object containing the address field.
 * Example: { address: "123 Main St, Cape Town, 8000" }
 * @returns {Promise<Object>} A promise resolving to the server's response.
 */
export const saveUserAddress = async (addressData) => {
    return securedApiRequest("/update-user-address/", "POST", addressData);
};

/**
 * Updates the user's profile photo by sending the new photo and user email to the server.
 *
 * @param {string} email - The email address of the user whose profile photo is being updated.
 * @param {File|Blob} profilePhotoData - The new profile photo data to be uploaded.
 * @returns {Promise<Object>} A promise resolving to the server response.
 */
export const changeProfilePhoto = async (email, profilePhotoData) => {
    const formData = new FormData();
    formData.append("profile_photo", profilePhotoData);
    formData.append("email", email);

    return securedApiRequest("/change-profile-picture/", "POST", formData);
};

/**
 * Change user password.
 * @param {string} email - User's email from auth context.
 * @param {string} currentPassword
 * @param {string} newPassword
 */
export const changePassword = async (email, currentPassword, newPassword) => {
    return securedApiRequest("/change-password/", "POST", {
        email,
        oldPassword: currentPassword,
        newPassword,
    });
};
